import React, { useState } from 'react';
import { LuChevronDown } from 'react-icons/lu';

import { Card } from '@/components/ui/card';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';

interface CollapsibleSectionProps {
    title: string | React.ReactNode;
    children: React.ReactNode;
    defaultOpen?: boolean;
    className?: string;
    headerClassName?: string;
}

export const CollapsibleSection = ({
    title,
    children,
    className,
    headerClassName,
    defaultOpen = true,
}: CollapsibleSectionProps) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <Card className={`overflow-hidden rounded-xl ${className || 'bg-gray-50'}`}>
            <Collapsible open={isOpen} onOpenChange={setIsOpen}>
                <CollapsibleTrigger
                    className={`text-cocoa-1000 flex w-full items-center justify-between rounded-t-xl px-4 py-3 text-base font-semibold ${headerClassName || (isOpen ? 'bg-[#f0ebe1]' : 'hover:bg-gray-100')}`}
                >
                    {typeof title === 'string' ? <span>{title}</span> : title}
                    <LuChevronDown
                        className={`h-5 w-5 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    />
                </CollapsibleTrigger>
                <CollapsibleContent className="p-4">{children}</CollapsibleContent>
            </Collapsible>
        </Card>
    );
};
